(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbdy-agent-locator"] && !Shopify.designMode) return;
  try {
    
  class NbdyAgentLocator extends HTMLElement {
    connectedCallback() {
      this.areas = this.querySelector('[data-agents-areas]');
      this.areaList = this.areas.firstElementChild;
      this.search = this.querySelector('[data-agents-search]');
      this.query = this.querySelector('[data-agents-query]');
      this.count = this.querySelector('[data-agents-count]');
      this.status = this.querySelector('[data-agents-status]');
      this.list = this.querySelector('[data-agents-list]');
      this.groupTemplate = this.querySelector('[data-agents-group]');
      this.cardTemplate = this.querySelector('[data-agents-card]');
      this.chosen = '';
      this.addEventListener('click', this.onClick);
      this.addEventListener('input', this.onInput);
      this.addEventListener('submit', this.onSubmit);
      this.load();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('input', this.onInput);
      this.removeEventListener('submit', this.onSubmit);
    }

    onClick = (event) => {
      const button = event.target.closest('[data-agents-filter]');
      if (!button) return;
      this.chosen = button.dataset.agentsFilter;
      this.areaList.querySelectorAll('[data-agents-filter]').forEach((item) => {
        item.setAttribute('aria-pressed', String(item.dataset.agentsFilter === this.chosen));
      });
      this.apply();
    };

    onInput = (event) => {
      if (event.target === this.query) this.apply();
    };

    // the list filters as you type, so submit only closes the keyboard
    onSubmit = (event) => {
      event.preventDefault();
      this.apply();
      this.query.blur();
    };

    async load() {
      try {
        const response = await fetch(this.dataset.endpoint, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(String(response.status));
        const data = await response.json();
        if (data.ok !== true || !Array.isArray(data.agents)) throw new Error('No agent list');
        if (data.agents.length === 0) {
          this.say(this.dataset.empty);
          return;
        }
        this.render(data.agents);
        this.status.hidden = true;
      } catch {
        this.say(this.dataset.error);
      }
    }

    // a message in place of the list
    say(message) {
      this.list.replaceChildren();
      this.areas.hidden = true;
      this.search.hidden = true;
      this.count.hidden = true;
      this.status.textContent = message;
      this.status.hidden = false;
    }

    // one group per state, in the order the app sorted them
    render(agents) {
      const groups = new Map();
      for (const agent of agents) {
        const state = String(agent.state || '');
        if (!groups.has(state)) {
          const group = this.groupTemplate.content.firstElementChild.cloneNode(true);
          group.dataset.state = state;
          group.querySelector('.nbdy-agents__state').textContent = state;
          groups.set(state, group);
        }
        groups.get(state).querySelector('.nbdy-agents__grid').append(this.card(agent));
      }
      this.list.replaceChildren(...groups.values());

      this.chosen = '';
      this.areaList.replaceChildren();
      if (groups.size > 1) {
        this.areaList.append(this.filter('', this.dataset.all, true));
        groups.forEach((_, state) => this.areaList.append(this.filter(state, state, false)));
      }
      this.areas.hidden = groups.size < 2;
      this.search.hidden = false;
      this.count.hidden = false;
      this.apply();
    }

    // the state tab and every search word must match
    apply() {
      const words = this.query.value.toLowerCase().split(/\s+/).filter(Boolean);
      let shown = 0;
      this.list.querySelectorAll('.nbdy-agents__group').forEach((group) => {
        const inState = this.chosen === '' || group.dataset.state === this.chosen;
        let inGroup = 0;
        group.querySelectorAll('.nbdy-agents__card').forEach((card) => {
          card.hidden = !inState || !words.every((word) => card.dataset.search.includes(word));
          if (!card.hidden) inGroup += 1;
        });
        group.hidden = inGroup === 0;
        shown += inGroup;
      });
      this.count.textContent = shown === 0 ? this.dataset.noMatch : `${shown} ${shown === 1 ? 'agent' : 'agents'}`;
    }

    // text only: names and areas are never parsed as HTML
    card(agent) {
      const card = this.cardTemplate.content.firstElementChild.cloneNode(true);
      const name = String(agent.name || '');
      const digits = String(agent.phone).replace(/\D/g, '');
      card.querySelector('[data-agent-name]').textContent = name;
      card.dataset.search = [name, agent.area, agent.state].join(' ').toLowerCase();

      const area = card.querySelector('[data-agent-area]');
      if (agent.area) area.textContent = agent.area;
      else area.remove();

      const call = card.querySelector('[data-agent-call]');
      call.href = `tel:+${digits}`;
      call.setAttribute('aria-label', `Call ${name}`);

      const whatsapp = card.querySelector('[data-agent-whatsapp]');
      whatsapp.href = `https://wa.me/${digits}`;
      whatsapp.setAttribute('aria-label', `WhatsApp ${name} (opens in a new tab)`);
      return card;
    }

    filter(value, label, pressed) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'nbdy-agents__filter';
      button.dataset.agentsFilter = value;
      button.setAttribute('aria-pressed', String(pressed));
      button.textContent = label;
      return button;
    }
  }

  if (!customElements.get('nbdy-agent-locator')) customElements.define('nbdy-agent-locator', NbdyAgentLocator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbdy-drops-rail"] && !Shopify.designMode) return;
  try {
    
  /* liquid does not render in here, merchant strings arrive as data attributes */
  const NBDY_ADDED_MS = 1500;

  class NbdyDropsRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rail-track]');
      if (!this.track) return;

      this.prevButton = this.querySelector('[data-rail-prev]');
      this.nextButton = this.querySelector('[data-rail-next]');
      this.timers = new WeakMap();

      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.prevButton?.addEventListener('click', () => this.page(-1));
      this.nextButton?.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKeydown);
      this.addEventListener('submit', this.onSubmit);

      this.syncArrows();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.syncArrows());
        this.resizeObserver.observe(this.track);
      }
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('submit', this.onSubmit);
      this.resizeObserver?.disconnect();
    }

    get reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    get cards() {
      return Array.from(this.querySelectorAll('[data-rail-card]'));
    }

    onScroll() {
      this.syncArrows();
    }

    page(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;

      this.track.scrollBy({
        left: step * direction,
        behavior: this.reduceMotion ? 'auto' : 'smooth',
      });
    }

    syncArrows() {
      if (!this.prevButton && !this.nextButton) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      if (this.prevButton) this.prevButton.disabled = scrollLeft <= 1;
      if (this.nextButton) this.nextButton.disabled = scrollLeft >= maxScroll - 1;
    }

    onKeydown(event) {
      const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
      if (!keys.includes(event.key)) return;

      const cards = this.cards;
      if (!cards.length) return;

      const current = cards.indexOf(event.target.closest('[data-rail-card]'));
      if (current === -1) return;

      let next = current;
      if (event.key === 'ArrowRight') next = Math.min(current + 1, cards.length - 1);
      if (event.key === 'ArrowLeft') next = Math.max(current - 1, 0);
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = cards.length - 1;
      if (next === current) return;

      event.preventDefault();
      cards[next].focus();
      cards[next].scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: this.reduceMotion ? 'auto' : 'smooth',
      });
    }

    async onSubmit(event) {
      const form = event.target.closest('[data-rail-form]');
      if (!form || typeof window.fetch !== 'function') return;

      const button = form.querySelector('[data-rail-add]');
      const label = form.querySelector('[data-rail-add-label]');
      const error = form.querySelector('[data-rail-error]');
      if (!button || button.disabled) return;

      event.preventDefault();

      const addUrl = this.dataset.cartAddUrl || '/cart/add';
      const cartUrl = this.dataset.cartUrl || '/cart';
      const originalLabel = label ? label.textContent : '';

      clearTimeout(this.timers.get(button));
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }

      /* pin the width so the label swap cannot collapse the button */
      button.style.minInlineSize = `${button.getBoundingClientRect().width}px`;
      button.setAttribute('aria-busy', 'true');

      try {
        const body = new FormData(form);
        body.delete('return_to');

        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload?.description || payload?.message || '');
        const cartResponse = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
        const cart = cartResponse.ok ? await cartResponse.json() : null;

        if (label) label.textContent = this.dataset.addedLabel || 'Added';

        const cartEvent = new Event('cart:update', { bubbles: true });
        cartEvent.detail = {
          resource: cart || payload,
          sourceId: this.id || 'nbdy-drops-rail',
          data: {
            source: 'nbdy-drops-rail',
            itemCount: cart ? cart.item_count : undefined,
            variantId: String(body.get('id') || ''),
          },
        };
        this.dispatchEvent(cartEvent);

        this.timers.set(
          button,
          setTimeout(() => {
            if (label) label.textContent = originalLabel;
            button.style.removeProperty('min-inline-size');
          }, NBDY_ADDED_MS)
        );
      } catch (failure) {
        if (label) label.textContent = originalLabel;
        button.style.removeProperty('min-inline-size');
        if (error) {
          error.textContent = failure.message || this.dataset.errorLabel || 'Could not add. Try again.';
          error.hidden = false;
        }
      } finally {
        button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('nbdy-drops-rail')) {
    customElements.define('nbdy-drops-rail', NbdyDropsRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbdy-newsroom"] && !Shopify.designMode) return;
  try {
    
  /* liquid does not render in here, copy and file lists arrive as data attributes */
  const NBDY_LANG_KEY = 'nbdy-lang';
  const NBDY_JSZIP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';

  let nbdyJsZip = null;

  function nbdyLoadJsZip() {
    if (window.JSZip) return Promise.resolve();
    if (!nbdyJsZip) {
      nbdyJsZip = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = NBDY_JSZIP_URL;
        script.onload = resolve;
        script.onerror = () => {
          nbdyJsZip = null;
          reject(new Error('JSZip did not load'));
        };
        document.head.appendChild(script);
      });
    }
    return nbdyJsZip;
  }

  // names arrive with their extension, anything else becomes a dash
  function nbdySafeName(raw, index) {
    const name = String(raw || `file-${index + 1}`)
      .replace(/[^a-zA-Z0-9\-_.]/g, '-')
      .replace(/-+/g, '-');
    return /\.[a-z0-9]{2,4}$/i.test(name) ? name : `${name}.jpg`;
  }

  class NbdyNewsroom extends HTMLElement {
    connectedCallback() {
      this.reveal();
      this.bindLanguage();
      this.playVideos();

      this.querySelectorAll('[data-nbdy-zip]').forEach((button) => {
        button.addEventListener('click', () => this.download(button));
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.motionQuery?.removeEventListener('change', this.onMotion);
    }

    // blocks rise in once as they reach the viewport
    reveal() {
      if (!('IntersectionObserver' in window)) return;

      this.dataset.reveal = '';
      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          }
        },
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
      );
      this.querySelectorAll('[data-nbdy-reveal]').forEach((el) => this.observer.observe(el));
    }

    bindLanguage() {
      this.langButtons = Array.from(this.querySelectorAll('[data-nbdy-lang]'));
      if (!this.langButtons.length) return;

      this.langButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const lang = button.dataset.nbdyLang;
          this.applyLanguage(lang);
          try {
            localStorage.setItem(NBDY_LANG_KEY, lang);
          } catch (error) {}
        });
      });

      let stored = null;
      try {
        stored = localStorage.getItem(NBDY_LANG_KEY);
      } catch (error) {}
      if (stored === 'bm') this.applyLanguage('bm');
    }

    // a block without BM copy keeps its EN
    applyLanguage(lang) {
      this.querySelectorAll('[data-nbdy-copy]').forEach((el) => {
        const value = (lang === 'bm' && el.dataset.bm) || el.dataset.en;
        if (value !== undefined) el.innerHTML = value;
      });
      this.langButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.nbdyLang === lang));
      });
      this.setAttribute('lang', lang === 'bm' ? 'ms' : 'en');
    }

    // autoplay only runs while the visitor allows motion
    playVideos() {
      this.videos = Array.from(this.querySelectorAll('video[data-nbdy-autoplay]'));
      if (!this.videos.length) return;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => {
        for (const video of this.videos) {
          if (this.motionQuery.matches) {
            video.pause();
            continue;
          }
          const started = video.play();
          if (started && started.catch) started.catch(() => {});
        }
      };
      this.onMotion();
      this.motionQuery.addEventListener('change', this.onMotion);
    }

    // zips every file listed beside the button, JSZip loads on first use
    async download(button) {
      const block = button.closest('[data-nbdy-download]');
      const progress = block?.querySelector('[data-nbdy-progress]');
      const status = block?.querySelector('[data-nbdy-progress-status]');
      const fill = block?.querySelector('[data-nbdy-progress-fill]');

      const show = (text, pct) => {
        if (progress) progress.hidden = false;
        if (status) status.textContent = text;
        if (fill) fill.style.inlineSize = `${pct}%`;
      };

      let files = [];
      try {
        files = JSON.parse(block?.querySelector('[data-nbdy-zip-files]')?.textContent || '[]');
      } catch (error) {
        files = [];
      }
      if (!files.length) {
        show('No files to download yet.', 0);
        return;
      }

      button.disabled = true;
      try {
        show('Loading…', 5);
        await nbdyLoadJsZip();

        const zip = new window.JSZip();
        const folder = button.dataset.folder ? zip.folder(button.dataset.folder) : zip;
        let done = 0;

        await Promise.all(
          files.map(async (file, index) => {
            try {
              const response = await fetch(file.url);
              if (!response.ok) throw new Error(String(response.status));
              folder.file(nbdySafeName(file.name, index), await response.blob());
            } catch (error) {
              console.warn('NBDY newsroom: skipped', file.url, error);
            }
            done += 1;
            show(`Fetching files (${done}/${files.length})…`, Math.round(10 + (done / files.length) * 75));
          })
        );

        show('Creating zip file…', 88);
        const blob = await zip.generateAsync({ type: 'blob' }, (meta) => {
          show('Creating zip file…', Math.round(88 + meta.percent * 0.12));
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${button.dataset.filename || 'NBDY'}.zip`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(link.href), 10000);

        show('Done', 100);
        setTimeout(() => {
          if (progress) progress.hidden = true;
        }, 3000);
      } catch (error) {
        console.error('NBDY newsroom: download failed', error);
        show('Something went wrong. Please try again.', 0);
      } finally {
        button.disabled = false;
      }
    }
  }

  if (!customElements.get('nbdy-newsroom')) {
    customElements.define('nbdy-newsroom', NbdyNewsroom);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nbdy-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  class NbdyReviews extends HTMLElement {
    static months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    connectedCallback() {
      this.page = 1;
      this.pages = Number(this.dataset.pages) || 1;
      const offset = /^([+-])(\d{2})(\d{2})$/.exec(this.dataset.utcOffset || '');
      this.offsetMinutes = offset ? (offset[1] === '-' ? -1 : 1) * (Number(offset[2]) * 60 + Number(offset[3])) : 0;
      this.list = this.querySelector('[data-review-list]');
      this.template = this.querySelector('[data-review-template]');
      this.more = this.querySelector('[data-review-more]');
      this.moreError = this.querySelector('[data-review-more-error]');
      this.dialog = this.querySelector('[data-review-dialog]');
      this.viewer = this.querySelector('[data-review-viewer]');
      this.form = this.querySelector('[data-review-form]');
      this.seen = new Set(
        Array.from(this.querySelectorAll('[data-review-uuid]'), (item) => item.dataset.reviewUuid).filter(Boolean)
      );

      // script-only controls stay hidden until here
      this.querySelectorAll('[data-review-open]').forEach((button) => (button.hidden = false));
      if (this.more) this.more.hidden = this.page >= this.pages;

      this.addEventListener('click', this.onClick);
      this.form?.addEventListener('submit', this.onSubmit);
      this.dialog?.addEventListener('click', this.onBackdrop);
      this.viewer?.addEventListener('click', this.onBackdrop);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const target = event.target.closest('[data-review-open], [data-review-close], [data-review-more], [data-review-photo]');
      if (!target) return;
      if (target.hasAttribute('data-review-open')) this.openForm();
      else if (target.hasAttribute('data-review-close')) target.closest('dialog')?.close();
      else if (target.hasAttribute('data-review-more')) this.loadMore();
      else this.openPhoto(target.dataset.reviewPhoto);
    };

    // a click on the dialog itself, not its sheet, lands on the backdrop
    onBackdrop = (event) => {
      if (event.target === event.currentTarget) event.currentTarget.close();
    };

    openForm() {
      this.form.hidden = false;
      this.dialog.querySelector('[data-review-thanks]').hidden = true;
      this.dialog.showModal();
    }

    // the photo is built here, so the page never ships an empty img
    openPhoto(url) {
      if (!url) return;
      const img = document.createElement('img');
      img.className = 'nbdy-pdp-reviews__viewer-img';
      img.alt = 'Photo from a customer review';
      img.src = url;
      this.viewer.querySelector('[data-review-viewer-media]').replaceChildren(img);
      this.viewer.showModal();
    }

    async loadMore() {
      const next = this.page + 1;
      const url = new URL(this.dataset.endpoint);
      url.search = new URLSearchParams({
        url: this.dataset.shop,
        shop_domain: this.dataset.shop,
        platform: 'shopify',
        page: String(next),
        per_page: this.dataset.perPage,
        product_id: this.dataset.product,
      }).toString();

      this.more.disabled = true;
      this.moreError.hidden = true;
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(String(response.status));
        const data = await response.json();
        for (const review of data.reviews || []) {
          if (this.seen.has(review.uuid)) continue;
          this.seen.add(review.uuid);
          this.list.append(this.render(review));
        }
        this.page = next;
        this.pages = data.pagination?.total_pages || this.pages;
        this.more.hidden = this.page >= this.pages;
      } catch {
        this.moreError.hidden = false;
      } finally {
        this.more.disabled = false;
      }
    }

    render(review) {
      const item = this.template.content.firstElementChild.cloneNode(true);
      const rating = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
      const name = review.is_anonymous_reviewer ? 'Anonymous' : review.reviewer_name || 'Anonymous';
      item.dataset.reviewUuid = review.uuid || '';
      item.querySelector('[data-review-name]').textContent = name;
      item.querySelector('[data-review-verified]').hidden = !review.verified_buyer;

      const stars = item.querySelector('[data-review-stars]');
      stars.setAttribute('aria-label', `${rating} out of 5 stars`);
      stars.querySelectorAll('svg').forEach((star, index) => star.toggleAttribute('data-on', index < rating));

      const date = item.querySelector('[data-review-date]');
      const created = new Date(review.created_at);
      if (Number.isNaN(created.getTime())) {
        date.remove();
      } else {
        // store time, the same day the server prints for the first reviews
        const shop = new Date(created.getTime() + this.offsetMinutes * 60000);
        date.dateTime = review.created_at;
        date.textContent = `${shop.getUTCDate()} ${NbdyReviews.months[shop.getUTCMonth()]} ${shop.getUTCFullYear()}`;
      }

      const title = item.querySelector('[data-review-title]');
      title.textContent = review.title || '';
      title.hidden = !review.title;

      this.fillLines(item.querySelector('[data-review-body]'), review.body || review.body_html || '');

      const pics = item.querySelector('[data-review-pics]');
      const photos = (review.pictures_urls || []).slice(0, 5).map(this.picture).filter((photo) => photo.thumb);
      pics.replaceChildren();
      pics.hidden = photos.length === 0;
      photos.forEach((photo, index) => {
        const entry = document.createElement('li');
        const button = document.createElement('button');
        const img = document.createElement('img');
        button.type = 'button';
        button.className = 'nbdy-pdp-reviews__pic';
        button.dataset.reviewPhoto = photo.full;
        button.setAttribute('aria-label', `Open photo ${index + 1} from ${name}`);
        img.src = photo.thumb;
        img.alt = '';
        img.width = 72;
        img.height = 72;
        img.loading = 'lazy';
        button.append(img);
        entry.append(button);
        pics.append(entry);
      });

      const reply = item.querySelector('[data-review-reply]');
      reply.hidden = !review.reply_content;
      if (review.reply_content) this.fillLines(reply.querySelector('[data-review-reply-body]'), review.reply_content);
      return item;
    }

    // Judge.me sends either plain URLs or a set of sizes
    picture(pic) {
      if (typeof pic === 'string') return { thumb: pic, full: pic };
      const sizes = pic?.urls || pic || {};
      const thumb = sizes.compact || sizes.small || sizes.original || sizes.huge || '';
      return { thumb, full: sizes.huge || sizes.original || thumb };
    }

    // text only: Judge.me's HTML is parsed, never injected
    fillLines(target, source) {
      let text = source;
      if (/<[a-z]/i.test(source)) {
        const doc = new DOMParser().parseFromString(source, 'text/html');
        doc.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
        const blocks = doc.body.querySelectorAll('p');
        text = blocks.length ? Array.from(blocks, (block) => block.textContent).join('\n') : doc.body.textContent;
      }
      target.replaceChildren();
      text.split('\n').forEach((line, index) => {
        if (index) target.append(document.createElement('br'));
        target.append(line);
      });
    }

    // form encoded, so the cross origin post needs no preflight
    onSubmit = async (event) => {
      event.preventDefault();
      const form = event.currentTarget;
      const status = form.querySelector('[data-review-status]');
      const submit = form.querySelector('[type="submit"]');
      const fields = new FormData(form);
      const body = new URLSearchParams({
        shop_domain: this.dataset.shop,
        platform: 'shopify',
        id: this.dataset.product,
        name: fields.get('name') || '',
        email: fields.get('email') || '',
        rating: fields.get('rating') || '',
        title: fields.get('title') || '',
        body: fields.get('body') || '',
      });

      submit.disabled = true;
      status.textContent = '';
      try {
        const response = await fetch(this.dataset.createEndpoint, { method: 'POST', body });
        if (!response.ok) {
          const reply = await response.json().catch(() => null);
          throw new Error(reply?.message || reply?.error || String(response.status));
        }
        form.reset();
        form.hidden = true;
        const thanks = this.dialog.querySelector('[data-review-thanks]');
        thanks.hidden = false;
        thanks.focus();
      } catch (error) {
        status.textContent = `${this.dataset.errorText} ${error.message}`.trim();
      } finally {
        submit.disabled = false;
      }
    };
  }

  if (!customElements.get('nbdy-reviews')) customElements.define('nbdy-reviews', NbdyReviews);

  } catch(e) { console.error(e); }
})();
})();
